// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--3UWLp","show":"styles-module--show--3K26E","text":"styles-module--text--1hx6F"};